import { UserInfo } from "components/user-info";
import gadget from "assets/img/gadget.svg";
import AvatarCharacter from "components/avatar-character";
import avatarDefault from "assets/avatar-editor/avatar_default.png";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  getMessages,
  likeMessage,
  removeMessage,
  sendMessage,
} from "services/messages.service";
import { useAppStore } from "store";
import { formatDistance } from "date-fns";
import { BiMessage, BiReply, BiTrash } from "react-icons/bi";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import { useModal } from "context/ModalContext";
import { ArrowArcRight, Calendar, CalendarBlank } from "@phosphor-icons/react";
import { getCharacterById } from "utils/regions";
import { es } from "date-fns/locale";

import missionInviteSticker from "assets/img/stickers/mission-invite.jpg";
import missionCompleteSticker from "assets/img/stickers/mission-complete.jpg";

export default function Notifications() {
  const { user } = useAppStore();
  const navigate = useNavigate();
  const { showModal } = useModal();
  const [messages, setMessages] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const toggleLikeMessage = useCallback(
    (messageId: string) => {
      setMessages((prev) =>
        prev.map((message) => {
          if (message._id === messageId) {
            const updatedMessage = {
              ...message,
              like: !message.like,
              updated: new Date().getTime(),
            };
            // call API to update message
            likeMessage(updatedMessage);

            if (!message.like) {
              // Send Like message
              const payload = {
                _id: `like_${message._id}`,
                origin: message._id,
                to: [message.from],
                content: "❤️ ¡Me gusto!",
                template: null,
                type: "notification",
                sender: "Custom",
                from: user?._id,
                time: new Date().getTime(),
              };

              sendMessage(payload);
            }

            return updatedMessage;
          }
          return message;
        }),
      );
    },
    [user],
  );

  const replyMessage = useCallback(
    async (message: any) => {
      console.log("message", message);
      showModal("message-composer", {
        friend: {
          _id: message.from,
          name: message.nombreUsuario,
          image: {
            original: {
              url: message.image,
            },
          },
        },
      });
    },
    [showModal],
  );

  const gotoMission = useCallback(
    (message: any) => {
      navigate(
        `/region/${message.region}?mission=${message.mission}&friend=${message.from}&region=${message.region}`,
      );
    },
    [navigate],
  );

  const loadMessages = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    const data = await getMessages(user._id);
    setMessages(data);
    setLoading(false);
  }, [user]);

  const handleRemoveMessage = useCallback(
    async (message: any) => {
      await removeMessage({
        ...message,
        updated: new Date().getTime(),
        status: "deleted",
      });
      loadMessages();
    },
    [loadMessages],
  );

  useEffect(() => {
    loadMessages();
    window.localStorage.setItem(
      "game-notification-lastvisit",
      new Date().getTime().toString(),
    );
  }, [loadMessages]);

  const renderMessages = useCallback(() => {
    function renderImage(message: any) {
      if (message.sender !== "Custom") {
        return (
          <>
            {message.sticker && message.from ? (
              <div className="border-2 border-white shadow-xl absolute top-0 bottom-0 my-auto right-12 md:right-14 z-20 w-10 h-10 bg-gray-200 rounded-full overflow-hidden">
                <img
                  src={getCharacterById(message.from)}
                  alt=""
                  className="w-full h-full"
                />
              </div>
            ) : null}
            {message.sticker ? (
              <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden">
                <img src={message.sticker} alt="" className="w-full h-full" />
              </div>
            ) : null}
            {!message.sticker && message.from ? (
              <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden">
                <img
                  src={getCharacterById(message.from)}
                  alt=""
                  className="w-full h-full"
                />
              </div>
            ) : null}
          </>
        );
      }

      if (message.sender === "Custom") {
        return (
          <>
            {(message.sticker || message.mission) && message.from ? (
              <div className="border-2 border-white shadow-xl absolute top-0 bottom-0 my-auto right-12 md:right-14 z-20 w-10 h-10 bg-gray-200 rounded-full overflow-hidden">
                <img src={message.image} alt="" className="w-full h-full" />
              </div>
            ) : null}
            {message.sticker ? (
              <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden">
                <img src={message.sticker} alt="" className="w-full h-full" />
              </div>
            ) : null}
            {message.mission && !message.completed ? (
              <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden">
                <img
                  src={missionInviteSticker}
                  alt=""
                  className="w-full h-full"
                />
              </div>
            ) : null}
            {message.mission && message.completed ? (
              <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden">
                <img
                  src={missionCompleteSticker}
                  alt=""
                  className="w-full h-full"
                />
              </div>
            ) : null}
            {!message.sticker && !message.mission && message.from ? (
              <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden">
                <img src={message.image} alt="" className="w-full h-full" />
              </div>
            ) : null}
          </>
        );
      }

      if (message.sticker) {
        return (
          <div className="w-16 h-16 bg-gray-200 rounded-lg overflow-hidden">
            <img src={message.sticker} alt="" className="w-full h-full" />
          </div>
        );
      }

      if (message.image) {
        return (
          <div className="border-2 border-white shadow-xl absolute top-0 bottom-0 my-auto right-16 z-20 w-10 h-10 bg-gray-200 rounded-full overflow-hidden">
            <img src={message.image} alt="" className="w-full h-full" />
          </div>
        );
      }

      return null;
    }

    return (
      <div className="absolute top-20 bottom-3 left-5 md:left-auto right-5 md:right-10 flex flex-col gap-2 overflow-y-auto">
        <Button
          className="bg-brand-red text-white rounded-lg ml-5 md:ml-10"
          onClick={() => navigate("/friends")}
        >
          <div className="flex items-center gap-2 justify-between">
            <BiMessage className="h-6 w-6" />
            <span>Enviar nuevo mensaje</span>
          </div>
        </Button>
        <div className="relative z-10 flex-1 flex flex-col gap-2 pl-5 pr-1 md:pl-10 overflow-y-auto scroll-menu">
          {messages.map((message) => {
            return (
              <div
                key={message._id}
                className="md:w-[320px] flex flex-wrap bg-white rounded-lg p-2 gap-2"
              >
                <div className="w-full flex justify-between items-center gap-2">
                  <p className="text-xs text-gray-500">
                    <CalendarBlank size={16} className="inline mr-1" />
                    {formatDistance(new Date(message.time), new Date(), {
                      addSuffix: true,
                      locale: es,
                    })}
                  </p>
                  <div
                    className="cursor-pointer hover:ring-1 hover:rounded-lg"
                    onClick={() => handleRemoveMessage(message)}
                  >
                    <BiTrash className="text-red-500" />
                  </div>
                </div>
                <div className="relative">{renderImage(message)}</div>
                <div className="flex-1 flex flex-col justify-between ">
                  <div className="flex items-center justify-between  text-brand-blue">
                    {message.from && message.sender !== "Custom" ? (
                      <p className="font-bold text-xs">{message.from}:</p>
                    ) : null}
                    {message.from && message.sender === "Custom" ? (
                      <p className="font-bold text-xs">
                        {message.nombreUsuario}:
                      </p>
                    ) : null}
                  </div>
                  <p
                    className="flex-1 mt-1 text-xs leading-tight"
                    dangerouslySetInnerHTML={{
                      __html: `${
                        message.mission
                          ? !message.completed
                            ? "<b>✋ Ven a completar esta misión conmigo: </b><br/>"
                            : "🎉 "
                          : ""
                      }${message.content}`,
                    }}
                  ></p>
                  <div className="flex items-center gap-2 justify-end mt-2 border-t border-dashed pt-1">
                    <div
                      className="flex items-center gap-1 text-xs text-red-500 px-1 cursor-pointer hover:ring-1 hover:rounded-lg"
                      onClick={() => toggleLikeMessage(message._id)}
                    >
                      {message.like ? (
                        <IoMdHeart
                          size={20}
                          className="text-red-500 font-bold"
                        />
                      ) : (
                        <IoMdHeartEmpty size={20} className="text-red-500" />
                      )}
                      me gusta
                    </div>
                    {!message.mission && message.sender === "Custom" ? (
                      <div
                        className="flex items-center gap-1 text-xs text-green-500 px-1 cursor-pointer hover:ring-1 hover:rounded-lg"
                        onClick={() => replyMessage(message)}
                      >
                        <BiReply size={20} className="text-green-500" />
                        responder
                      </div>
                    ) : null}
                    {message.mission ? (
                      <div
                        className="flex items-center gap-1 text-xs text-blue-500 px-1 cursor-pointer hover:ring-1 hover:rounded-lg"
                        onClick={() => gotoMission(message)}
                      >
                        <ArrowArcRight size={20} className="text-blue-500" />
                        Ver misión
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }, [
    gotoMission,
    messages,
    navigate,
    replyMessage,
    toggleLikeMessage,
    handleRemoveMessage,
  ]);

  return useMemo(
    () => (
      <>
        <div
          id="home"
          className={`absolute top-0 left-0 w-full h-full flex flex-col items-center md:justify-center overflow-y-auto overflow-x-hidden md:overflow-hidden scroll-wrapper`}
        >
          <UserInfo />

          <div className="absolute bottom-0 md:relative w-[270px] mt-[100px] md:mt-auto ml-[-150px] z-0">
            <AvatarCharacter responsive defaultAvatarUrl={avatarDefault} />
          </div>

          {loading || (!loading && !messages.length) ? (
            <div className="absolute right-4 md:right-10 bottom-10 md:bottom-20 w-[36vw] md:w-[15vw] animate-fly-fast delay-200 z-10">
              <div className="absolute right-0 bottom-full mb-5 bg-white w-[90vw] md:w-96 rounded-xl shadow p-5 space-y-2">
                {!loading ? (
                  <p className="leading-tight">
                    Aquí podrás recibir y enviar mensajes a tus amigos y también
                    recibir avisos importantes sobre nuestras actividades,
                    premios y otras cosas divertidas.
                  </p>
                ) : (
                  <p>Cargando...</p>
                )}
                {!loading ? (
                  <div className="pt-2">
                    <Button onClick={() => navigate("/friends")}>
                      Envía tu primer mensaje
                    </Button>
                  </div>
                ) : null}
              </div>
              <div className="rotate-12 relative">
                <img src={gadget} alt="" className="-scale-x-100" />
              </div>
            </div>
          ) : null}

          {!loading && messages.length ? renderMessages() : null}
        </div>
      </>
    ),
    [messages, loading, navigate, renderMessages],
  );
}
